import { AbstractPmsApiService } from "./abstract.service";
import { TaxFee } from "../models";

/**
 * @class TaxFeePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<TaxFee>}
 */
export class TaxFeePmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/tax-fee(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {TaxFee}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new TaxFee(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<TaxFee>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {TaxFee} taxFee
     * @param {Property} property
     * @returns {Promise.<TaxFee>}
     */
    create(taxFee, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, taxFee.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {TaxFee} taxFee
     * @returns {Promise.<TaxFee>}
     */
    update(taxFee) {
        
        const url = this.url({
            propertyId: taxFee.property.id,
            id:         taxFee.id
        });
        
        return this.http
                   .put(url, taxFee.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {TaxFee} taxFee
     * @returns {Promise.<boolean>}
     */
    delete(taxFee) {
        
        const url = this.url({
            propertyId: taxFee.property.id,
            id:         taxFee.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/tax-fee.service.js